import React, { ReactNode } from 'react';
import classNames from 'classnames';

import Text from '../../atoms/text/Text';
import Dropdown from '../../atoms/dropdown/Dropdown';
import { Button, ButtonProps } from '../../atoms/button';
import Badge from '../../atoms/badge/Badge';
import { BadgeProps } from '../../atoms/badge/Badge';
import { DropdownItemProps } from '../../atoms/dropdown/DropdownItem';

export interface MetricsDropDownInfo {
  name?: string;
  email?: string;
}

export interface MetricsProps {
  icon?: ReactNode;
  heading?: string;
  number?: string;
  badge?: BadgeProps;
  actionButton?: ButtonProps;
  chart?: ReactNode;
  headingInlineWithIcon?: boolean;
  dropDownInfo?: MetricsDropDownInfo;
  dropDownListItem?: DropdownItemProps[];
  actionIcon?: ReactNode;
  numberBadge?: BadgeProps;
  subtitleText?: string;
  subTitleBadge?: BadgeProps;
}

const Metrics = ({
  icon,
  heading,
  number,
  badge,
  actionButton,
  chart,
  headingInlineWithIcon = false,
  dropDownInfo,
  dropDownListItem,
  actionIcon,
  numberBadge,
  subtitleText,
  subTitleBadge,
}: MetricsProps) => {
  return (
    <div
      className={classNames('bg-white shadow-sm rounded-4 d-inline-block', {
        'metrics-min-width-with-chart': chart,
        'metrics-min-width': !chart,
      })}
    >
      <div className="d-flex justify-content-between gap-5 p-10">
        <div>
          <div
            className={classNames({
              'd-flex gap-5 align-items-center': headingInlineWithIcon,
            })}
          >
            {icon && <div>{icon}</div>}
            <Text
              component="h2"
              size={headingInlineWithIcon ? 'md' : 'sm'}
              weight={headingInlineWithIcon ? 'semibold' : 'medium'}
              color={headingInlineWithIcon ? 'dark' : 'subtitle1'}
            >
              {heading}
            </Text>
          </div>
          <div className="d-flex align-items-start gap-2">
            <Text component="p" weight="semibold" className="my-0 display-md">
              {number}
            </Text>
            {!!numberBadge && <Badge {...numberBadge} />}
          </div>
          {(subtitleText || subTitleBadge) && (
            <Text className="d-flex gap-3 mt-5">
              <Badge {...subTitleBadge} />
              {subtitleText}
            </Text>
          )}
        </div>
        <div className="d-flex flex-column justify-content-between align-items-end">
          <div>
            <Dropdown
              buttonType="icon"
              info={dropDownInfo}
              listItem={dropDownListItem}
            />
          </div>
          <div className="align-self-end">
            <div className="metrics-chart-max-width">{chart && chart}</div>
            {badge && <Badge {...badge} />}
          </div>
        </div>
      </div>
      {(actionButton || actionIcon) && (
        <div className="border-top">
          <div className="d-flex justify-content-between align-items-center py-5 px-10">
            <div>{actionIcon && actionIcon}</div>
            <Button {...actionButton} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Metrics;
